import React, { useState } from 'react';
import {
  Container, PaperForm, InputContainer, InputText, Form,
  DatePicker, ButtonGrouped, ButtonColor,
  ContainerLoading, ButtonLoading, ContainerButtons
} from './styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ptBR } from 'date-fns/locale'
import DateFnsUtils from '@date-io/date-fns';
import {format} from 'date-fns';
import { Button, Tooltip, Slide, Icon } from '@material-ui/core';
import Api from '../../plugins/Api';
import TableResult from '../../components/TableResult';
import Dicas from '../../components/Dicas';
import Zoom from '@material-ui/core/Zoom';
import SnackBar from '../../components/SnackBar';

function Home({logado, verificaLoginExpirado}) {
  const [nomeDoc, setNomeDoc] = useState('');
  const [nomeOrg, setNomeOrg] = useState('');
  const [numParecer, setNumParecer] = useState('');
  const [assunto, setAssunto] = useState('');
  const [decisao, setDecisao] = useState('');
  const [dtInicial, setDtInicial] = useState(null);
  const [dtFinal, setDtFinal] = useState(null);
  const [frase, setFrase] = useState('');
  const [data, setData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [filtroAberto, setFiltroAberto] = useState(true);
  const [msgError, setMsgError] = useState('');
  const [msgErroDataI, setMsgErroDataI] = useState('')
  const [msgErroDataF, setMsgErroDataF] = useState('')
  const [dicasAberta, setDicasAberta] = useState(false)
  const [loading, setLoading] = useState(false);
  const [botoes] = useState(
    [{
      texto: 'e',
      tooltip: 'Furto e estacionamento e supermercado',
      exemplo: 'Localiza as três palavras em qualquer lugar do documento.'
    },
    {
      texto: 'ou',
      tooltip: 'Furto e estacionamento e (supermercado ou hipermercado ou mercado)',
      exemplo: 'Localiza um e/ou outro termo digitado entre parênteses.'
    },
    {
      texto: 'menos',
      tooltip: 'Furto e estacionamento menos supermercado',
      exemplo: 'Localiza documentos que contenham as palavras "furto" e "estacionamento", excluindo documentos que contenham a palavra "supermercado".'
    },
    {
      texto: '*',
      tooltip: `Furto e estacionamento e *mercado`,
      exemplo: 'Localiza as palavras que contenham a parte digitada e suas variações: supermercado, hipermercado ou mercado.'
    }]);

  const addTexto = (texto) => {
    if(texto === '*') 
      setFrase(frase.trimRight() + `${texto}`);
    else
      setFrase(frase.trimRight() + ` ${texto} `);

    document.querySelector("#frase").focus();
  }

  const pesquisar = () => {
    const expirado = verificaLoginExpirado();
    if(expirado) {
      msgErro('Sessão expirou!')
      return;
    }
    if(disableSearch() || loading)
      return;

    let params = ''
    if (filtroAberto) {
      params = dtInicial ? params + `${params.includes('=') ? '&' : ''}dtInit=${format(dtInicial,"MM/dd/yyyy")}` : params
      params = dtFinal ? params + `${params.includes('=') ? '&' : ''}dtEnd=${format(dtFinal,"MM/dd/yyyy")}` : params
      params = frase ? params + `${params.includes('=') ? '&' : ''}descricao=${frase}` : params
      params = nomeDoc ? params + `${params.includes('=') ? '&' : ''}nome=${nomeDoc}` : params
      params = nomeOrg ? params + `${params.includes('=') ? '&' : ''}interessado=${nomeOrg}` : params
      params = numParecer ? params + `${params.includes('=') ? '&' : ''}emitenteNr=${numParecer}` : params
      params = decisao ? params + `${params.includes('=')  ? '&' : ''}nrDecisao=${decisao}` : params
      params = assunto ? params + `${params.includes('=') ? '&' : ''}assunto=${assunto}` : params
      params = logado ? params + `${params.includes('=') ? '&' : ''}logado=${logado}` : params
    }
    else {
      params = frase ? params + `${params.includes('=') ? '&' : ''}descricao=${frase}` : params
      params = logado ? params + `${params.includes('=') ? '&' : ''}logado=${logado}` : params
    }
    setLoading(true);
    Api.get(`${process.env.REACT_APP_BASEURL_API}/pesquisar?${params}`)
      .then(response => {
        setLoading(false);
        if (!response){
          setData([]);
          msgErro("Erro ao consultar o servidor!");
          return;
        }
        if (response.status === 404) {
          setData([]);
          msgErro(response.data.statusMessage ?? "Erro ao consultar o servidor!");
          return;
        }
        if (response.status !== 200 || response.data.error) {
          setData([]);
          msgErro(response.data.statusMessage ?? "Erro ao consultar o servidor!")
          return;
        }
        if (response.data.data.length > 0) {
          setData(response.data.data);
          setFiltroAberto(false);
        }
      })
      .catch(err => {
        setLoading(false);
        setData([]);
        msgErro("Erro ao consultar o servidor!");
        return;
      })
  }

  const msgErro = (texto) => {
    setMsgError(texto);
    setOpen(true);
  }

  const handleDate = (date, inicial) => {
    if (inicial) {
      setMsgErroDataI('');
      setDtInicial(date);
      if (!date)
        setMsgErroDataI('');
    }
    else {
      setMsgErroDataF('');
      setDtFinal(date);
      if (!date)
        setMsgErroDataF('');
    }
  }

  const handleClear = (minimizar) => {
    setNomeDoc('');
    setNomeOrg('');
    setNumParecer('');
    setDecisao('');
    setDtInicial(null);
    setDtFinal(null);
    setAssunto('');
    if (!minimizar)
      setFrase('');
  }

  const disableSearch = () => {
    if ((!filtroAberto && !frase) ||
    (filtroAberto && !(nomeDoc || nomeOrg || numParecer || decisao || dtInicial || (dtFinal && !msgErroDataF) || assunto || frase))
    || msgErroDataI || msgErroDataF)
      return true;

    return false;
  }

  return (
    <Container>
      <PaperForm elevation={2}>
        <Form>
          {filtroAberto &&
            <>
              <InputContainer>
                <span>Nome documento</span>
                <InputText value={nomeDoc} onChange={(e) => setNomeDoc(e.target.value)} onKeyUp={(e) => e.keyCode === 13 ? pesquisar(e) : null } />
              </InputContainer>
              <InputContainer>
                <span>Nome do interessado ou do órgão consulente</span>
                <InputText value={nomeOrg} onChange={(e) => setNomeOrg(e.target.value)} onKeyUp={(e) => e.keyCode === 13 ? pesquisar(e) : null } />
              </InputContainer>
              <InputContainer>
                <span>Número do(a) parecer/manifestação</span>
                <InputText value={numParecer} onChange={(e) => setNumParecer(e.target.value)} onKeyUp={(e) => e.keyCode === 13 ? pesquisar(e) : null } />
              </InputContainer>
              <InputContainer>
                <span>Decisão GAB n.º</span>
                <InputText value={decisao} onChange={(e) => setDecisao(e.target.value)} onKeyUp={(e) => e.keyCode === 13 ? pesquisar(e) : null } />
              </InputContainer>
              <InputContainer>
                <span>Data Inicial</span>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                  <DatePicker
                    autoOk
                    clearable="true"
                    variant="inline"
                    value={dtInicial}
                    placeholder="01/01/2020"
                    onChange={date => handleDate(date, true)}
                    format="dd/MM/yyyy"
                    helperText={msgErroDataI}
                    error={Boolean(msgErroDataI)}
                    onError={error => {
                      if (error !== msgErroDataI) {
                        setMsgErroDataI('Formato inválido de data!');
                      }
                    }}
                    onKeyUp={(e) => e.keyCode === 13 ? pesquisar(e) : null }
                  />
                </MuiPickersUtilsProvider>
              </InputContainer>
              <InputContainer>
                <span>Data Final</span>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                  <DatePicker
                    autoOk
                    clearable="true"
                    variant="inline"
                    value={dtFinal}
                    placeholder="01/01/2020"
                    onChange={date => handleDate(date, false)}
                    format="dd/MM/yyyy"
                    helperText={msgErroDataF}
                    error={Boolean(msgErroDataF)}
                    onError={error => {
                      if (error !== msgErroDataF) {
                        setMsgErroDataF('Formato inválido de data!');
                      }
                    }}
                    onKeyUp={(e) => e.keyCode === 13 ? pesquisar(e) : null }
                  />
                </MuiPickersUtilsProvider>
              </InputContainer>
              <InputContainer>
                <span>Assunto</span>
                <InputText value={assunto} onChange={(e) => setAssunto(e.target.value)} onKeyUp={(e) => e.keyCode === 13 ? pesquisar(e) : null } />
              </InputContainer>
            </>}
          <InputContainer size="100%">
            <span>Busque palavra ou frase dentro do texto:</span>
            <InputText id="frase" value={frase} onChange={(e) => setFrase(e.target.value)} onKeyUp={(e) => e.keyCode === 13 ? pesquisar(e) : null } />
            <ButtonGrouped size="small">
              {botoes.map(botao =>
                <Tooltip key={botao.texto} title={
                  <>
                    <h3 style={{ textAlign: 'center' }}>{botao.texto}</h3>
                    <p>Exemplo: {botao.tooltip} </p>
                    <p>Resultado: {botao.exemplo} </p>
                  </>
                }
                  TransitionComponent={Zoom}
                  TransitionProps={{ timeout: 600 }}
                  arrow
                >
                  <Button onClick={() => addTexto(botao.texto)}>
                    {botao.texto}
                  </Button>
                </Tooltip>
              )}
            </ButtonGrouped>
          </InputContainer>
        </Form>
        <ContainerButtons>
          <ButtonColor
            variant="contained"
            bgColor="#e0e0e0"
            txtColor="#000"
            startIcon={<Icon>live_help</Icon>}
            onClick={() => setDicasAberta(!dicasAberta)}
          >
            Dicas
          </ButtonColor>
          <ButtonColor
            variant="contained"
            bgColor="#e0e0e0"
            txtColor="#000"
            startIcon={<Icon>{filtroAberto ? 'remove' : 'add'}</Icon>}
            onClick={() => setFiltroAberto(!filtroAberto)}
          >
            {filtroAberto ? 'Menos' : 'Mais'} Filtros
        </ButtonColor>
          <ButtonColor
            variant="contained"
            bgColor="#e0e0e0"
            txtColor="#000"
            startIcon={<Icon>delete</Icon>}
            onClick={() => handleClear()}
          >
            LIMPAR
        </ButtonColor>
          {!loading &&
            <ButtonColor
              variant="contained"
              onClick={() => pesquisar()}
              startIcon={<Icon>search</Icon>}
              disabled={ disableSearch() }
            >
              PESQUISAR
            </ButtonColor>}
          {loading &&
            <ContainerLoading>
              <ButtonColor bgColor="#e0e0e0" startIcon={<Icon>search</Icon>} disabled={true}>
                PESQUISAR
              </ButtonColor>
              <ButtonLoading size={24} />
            </ContainerLoading>}
        </ContainerButtons>
        <Slide direction="right" in={dicasAberta} timeout={{enter:600, exit: 500, appear: 500}} mountOnEnter unmountOnExit>
          <div>
            <Dicas />
          </div>
        </Slide>
      </PaperForm>
      {data.length > 0 &&
        <TableResult data={data} logado={logado} />
      }
     <SnackBar open={open} setOpen={() => setOpen()} msgError={msgError} />
    </Container>
  );
}

export default Home;